export default __webpack_public_path__ + "static/media/20230918banner.da8ea7cb.png";